import GreyCatLintError from './lint-error';
import Scope from './scope';
import { NodeType } from './node-type';
import { string2type } from './helper';
export default (parser) => {
    const BaseGreyCatVisitor = parser.getBaseCstVisitorConstructor();
    return class GreyCatLinterVisitor extends BaseGreyCatVisitor {
        constructor() {
            super();
            this.validateVisitor();
        }
        visit(node, opts) {
            return super.visit(node, opts);
        }
        greycat(node, ctx) {
            let id = 0;
            ctx.id = () => id++;
            ctx.private = false;
            ctx.static = false;
            ctx.hasReturned = false;
            ctx.stack = new Scope('#main');
            ctx.types = new Map();
            ctx.errors = [];
            ctx.typeDecl = null;
            ctx.symbols = new Map();
            initTypings(ctx);
            if (node.stmt) {
                node.stmt.forEach((s) => this.visit(s, ctx));
            }
            console.log('Lint done', ctx);
            return {
                errors: ctx.errors,
            };
        }
        stmt(node, ctx) {
            if (node.funcDecl) {
                node.funcDecl.forEach((fDecl) => this.visit(fDecl, ctx));
            }
            if (node.typeDecl) {
                node.typeDecl.forEach((t) => this.visit(t, ctx));
            }
            if (node.assign) {
                node.assign.forEach((a) => this.visit(a, ctx));
            }
            if (node.varDecl) {
                node.varDecl.forEach((v) => this.visit(v, ctx));
            }
            if (node.funcCall) {
                node.funcCall.forEach((f) => this.visit(f, ctx));
            }
            if (node.block) {
                node.block.forEach((b) => this.visit(b, ctx));
            }
        }
        funcStmts(node, ctx) {
            if (node.funcStmt) {
                node.funcStmt.forEach((stmt) => this.visit(stmt, ctx));
            }
        }
        funcStmt(node, ctx) {
            if (node.funcCall) {
                this.visit(node.funcCall, ctx);
            }
            else if (node.assign) {
                this.visit(node.assign, ctx);
            }
            else if (node.varDecl) {
                this.visit(node.varDecl, ctx);
            }
            else if (node.funcDecl) {
                this.visit(node.funcDecl, ctx);
            }
            else if (node.block) {
                this.visit(node.block, ctx);
            }
            else if (node.return) {
                this.visit(node.return, ctx);
            }
            else if (node.ifStmt) {
                this.visit(node.ifStmt, ctx);
            }
        }
        block(node, ctx) {
            if (node.funcStmts) {
                const fScope = this.funcDecl(node, ctx);
                if (fScope) {
                    return fScope;
                }
            }
            return;
        }
        funcDecl(node, ctx) {
            const token = node.Identifier ? node.Identifier[0] : node.Function;
            const fName = node.Identifier ? node.Identifier[0].image : `#anonymous_function_${ctx.id()}`;
            const scope = ctx.stack.peek();
            if (ctx.strict && scope.hasRef(fName)) {
                ctx.errors.push(new GreyCatLintError('Should not override function implementation (strict-mode)', token, 'warning'));
            }
            const fScope = new Scope(fName);
            fScope.parent = scope;
            if (ctx.typeDecl) {
                const thisRef = new Scope('this');
                ctx.typeDecl.init(thisRef);
                fScope.setRef('this', { type: 'object', value: thisRef });
                if (node.Identifier) {
                    ctx.typeDecl.setFunc(fName, {
                        private: ctx.private,
                        static: ctx.static,
                        scope: fScope,
                    });
                }
                else {
                    ctx.errors.push(new GreyCatLintError('Anonymous function declaration are not allowed in type declaration', node.LParen));
                }
            }
            else {
                scope.setRef(fName, { type: 'function', value: fScope, token });
            }
            scope.push(fScope);
            if (node.funcStmts) {
                if (node.paramsDecl) {
                    this.visit(node.paramsDecl, ctx);
                }
                this.visit(node.funcStmts, ctx);
            }
            if (fScope.unreachableRange) {
                fScope.endUnreachable(node.RCurly[0]);
                ctx.errors.push(new GreyCatLintError('Unreachable code', fScope.unreachableRange));
            }
            scope.pop();
            return fScope;
        }
        paramsDecl(node, ctx) {
            if (node.paramDecl) {
                return node.paramDecl
                    .map((pDecl) => this.visit(pDecl, ctx))
                    .filter((pDecl) => pDecl);
            }
            return [];
        }
        paramDecl(node, ctx) {
            if (node.name && node.type) {
                const scope = ctx.stack.peek();
                scope.declareParam(node.name[0].image, node.type[0].image);
                scope.setRef(node.name[0].image, { type: string2type(node.type[0].image), value: null, token: node.type[0] });
                return {
                    name: node.name[0],
                    type: node.type[0],
                };
            }
            return;
        }
        typeDecl(node, ctx) {
            if (node.Identifier) {
                const name = node.Identifier[0].image;
                const type = new NodeType(name);
                ctx.types.set(name, type);
                ctx.typeDecl = type;
                if (node.typeStmt) {
                    node.typeStmt.forEach((t) => this.visit(t, ctx));
                }
                ctx.typeDecl = null;
            }
            return;
        }
        typeStmt(node, ctx) {
            ctx.private = Boolean(node.Private);
            ctx.static = Boolean(node.Static);
            if (node.attDecl) {
                this.visit(node.attDecl, ctx);
            }
            if (node.funcDecl) {
                this.visit(node.funcDecl, ctx);
            }
            ctx.private = false;
            ctx.static = false;
        }
        attDecl(node, ctx) {
            if (node.name && node.type) {
                if (ctx.typeDecl) {
                    ctx.typeDecl.setAtt(node.name[0].image, {
                        private: ctx.private,
                        static: ctx.static,
                        type: node.type[0].image,
                    });
                }
                if (ctx.static) {
                    if (!node.expr) {
                        ctx.errors.push(new GreyCatLintError('Static attributes must have an initializer.', node.name[0]));
                    }
                }
                else {
                    if (node.expr) {
                        ctx.errors.push(new GreyCatLintError('Non-static attributes cannot have an initializer.', node.name[0]));
                    }
                }
            }
        }
        ifStmt(node, ctx) {
            if (node.block) {
                this.visit(node.block, ctx);
            }
            if (node.thenStmt) {
                this.visit(node.thenStmt, ctx);
            }
        }
        thenStmt(node, ctx) {
            if (node.elseStmt) {
                this.visit(node.elseStmt, ctx);
            }
        }
        elseStmt(node, ctx) {
            if (node.block) {
                return this.visit(node.block, ctx);
            }
        }
        funcCall(node, ctx) {
            if (node.qName) {
                const qName = this.visit(node.qName, ctx);
                if (qName) {
                    const scope = ctx.stack.peek();
                    if (qName.length === 1) {
                        const fName = qName[0].image;
                        const ref = scope.getRef(fName);
                        if (ref !== undefined) {
                            console.log('FuncCall', `'${fName}'`, ref);
                            if (ref.type === 'function') {
                                const funcScope = ref.value;
                                scope.push(funcScope);
                                const params = node.params ? this.visit(node.params, ctx) : [];
                                verifyParams(params, ctx);
                                if (ctx.strict) {
                                    params.filter((p) => p.name !== undefined).forEach((p) => {
                                        const declType = funcScope.getParamDecl(p.name.image);
                                        if (declType) {
                                            if (!typeCheck(declType, p.ref.type, ctx)) {
                                                ctx.errors.push(new GreyCatLintError(`Argument of type '${p.ref.type}' is not assignable to parameter of type '${declType}'`, p.ref.token));
                                            }
                                        }
                                        else {
                                            let msg = `Function '${fName}' has no declared parameter '${p.name.image}'`;
                                            if (funcScope.params.size > 0) {
                                                msg += ` (available params: ${Array.from(funcScope.params.keys())
                                                    .map((k) => `'${k}'`)
                                                    .join(', ')})`;
                                            }
                                            else {
                                                msg += ` (no params in signature)`;
                                            }
                                            ctx.errors.push(new GreyCatLintError(msg, p.name));
                                        }
                                    });
                                }
                                scope.pop();
                            }
                            else {
                                ctx.errors.push(new GreyCatLintError(`Cannot invoke '${ref.type}' as a function.`, qName[0]));
                            }
                        }
                        else {
                            ctx.errors.push(new GreyCatLintError(`Cannot find function '${fName}' in '${scope.type}'`, qName[0]));
                        }
                    }
                    else if (qName.length === 2) {
                    }
                    else {
                        ctx.errors.push(new GreyCatLintError(`Using qualified name is restricted to 'src.prop' currently (given: '${asPath(qName)}')`, node.qName[0]));
                    }
                }
            }
        }
        params(node, ctx) {
            if (node.param) {
                return node.param.map((p) => this.visit(p, ctx)).filter((p) => p !== undefined);
            }
            return [];
        }
        param(node, ctx) {
            if (node.expr) {
                const ref = this.visit(node.expr, ctx);
                if (ref) {
                    if (node.Identifier) {
                        const name = node.Identifier[0];
                        return { ref, name };
                    }
                    else {
                        ctx.errors.push(new GreyCatLintError(`Parameter shorthand form is not implemented yet (specify 'name' and 'value')`, ref.token, 'warning'));
                    }
                }
            }
            return;
        }
        return(node, ctx) {
            const scope = ctx.stack.peek();
            if (node.expr) {
                const ref = this.visit(node.expr, ctx);
                if (ref) {
                    scope.setRef('result', ref);
                }
            }
            ctx.hasReturned = true;
        }
        assign(node, ctx) {
            if (node.qName && node.expr) {
                const scope = ctx.stack.peek();
                const qName = this.visit(node.qName, ctx);
                if (qName) {
                    let qNameSrc;
                    let qNameSrcProp;
                    if (qName.length > 1) {
                        qNameSrc = [...qName];
                        qNameSrcProp = qNameSrc.pop();
                    }
                    else {
                        qNameSrc = qName;
                    }
                    const targetRef = scope.resolve(qNameSrc, ctx);
                    const valueRef = this.visit(node.expr, ctx);
                    if (valueRef) {
                        if (targetRef) {
                            if (qNameSrcProp) {
                                if (targetRef.value) {
                                    if (targetRef.value instanceof Scope) {
                                        targetRef.value.setRef(qNameSrcProp.image, valueRef);
                                    }
                                    else {
                                        ctx.errors.push(new GreyCatLintError(`'${asPath(qNameSrc)}' is not an object`, qNameSrc[0]));
                                    }
                                }
                                else {
                                    ctx.errors.push(new GreyCatLintError(`'${asPath(qNameSrc)}' is undefined`, qNameSrc[0]));
                                }
                            }
                            else {
                                targetRef.value = valueRef.value;
                                targetRef.type = valueRef.type;
                                targetRef.token = valueRef.token;
                            }
                        }
                    }
                    else {
                        ctx.errors.push(new GreyCatLintError(`Unable to evaluate right-side expression`, qName[0]));
                    }
                }
            }
        }
        varDecl(node, ctx) {
            if (node.Identifier) {
                const scope = ctx.stack.peek();
                const targetName = node.Identifier[0].image;
                const prevRef = scope.getRef(targetName);
                if (prevRef !== undefined) {
                    ctx.errors.push(new GreyCatLintError(`Should not redeclare ${prevRef.type} '${targetName}'`, node.Identifier[0], 'warning'));
                }
                let value;
                if (node.expr) {
                    value = this.visit(node.expr, ctx);
                }
                if (value) {
                    scope.setRef(targetName, value);
                }
                else {
                    scope.setRef(targetName, { type: 'null', value: null, token: node.Identifier[0] });
                }
            }
        }
        inlineDecl(node, ctx) {
            const scope = ctx.stack.peek();
            const inlineScope = new Scope(`#inline_decl_${ctx.id()}`);
            scope.push(inlineScope);
            const params = this.visit(node.params, ctx);
            params.forEach((p) => inlineScope.setRef(p.name.image, p.ref));
            scope.pop();
            return inlineScope;
        }
        typedInlineDecl(node, ctx) {
            if (node.Identifier) {
                return this.visit(node.inlineDecl, ctx);
            }
            return;
        }
        binaryExpr(node, ctx) {
            if (node.lhs) {
                const lhs = this.visit(node.lhs, ctx);
                if (lhs) {
                    if (node.rhs) {
                        const rhs = this.visit(node.rhs, ctx);
                        if (rhs) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                    else {
                        return Boolean(lhs.value);
                    }
                }
                else {
                    return false;
                }
            }
            return false;
        }
        expr(node, ctx) {
            if (node.Null) {
                return { type: 'null', value: null, token: node.Null[0] };
            }
            else if (node.False) {
                return { type: 'boolean', value: false, token: node.False[0] };
            }
            else if (node.True) {
                return { type: 'boolean', value: true, token: node.True[0] };
            }
            else if (node.Num) {
                const num = node.Num[0].image;
                let value;
                if (num.indexOf('.') === -1) {
                    value = parseInt(node.Num[0].image, 10);
                }
                else {
                    value = parseFloat(node.Num[0].image);
                }
                return { type: 'number', value, token: node.Num[0] };
            }
            else if (node.newDecl) {
                const instance = this.visit(node.newDecl, ctx);
                if (instance) {
                    return { type: 'object', value: instance, token: node.newDecl[0].children.Identifier[0] };
                }
            }
            else if (node.inlineDecl) {
                return { type: 'object', value: this.visit(node.inlineDecl, ctx), token: node.inlineDecl };
            }
            else if (node.typedInlineDecl) {
                return { type: 'object', value: this.visit(node.typedInlineDecl, ctx), token: node.typedInlineDecl };
            }
            else if (node.arrayDecl) {
                return { type: 'array', value: this.visit(node.arrayDecl, ctx), token: node.arrayDecl };
            }
            else if (node.typedArrayDecl) {
                return { type: 'array', value: this.visit(node.typedArrayDecl, ctx), token: node.typedArrayDecl };
            }
            else if (node.funcDecl) {
                return { type: 'function', value: this.visit(node.funcDecl, ctx), token: node.funcDecl };
            }
            else if (node.funcCall) {
                const fCall = this.visit(node.funcCall, ctx);
                if (fCall) {
                    return { type: fCall.type, value: fCall.value, token: node.funcCall };
                }
            }
            else if (node.stringLiteral) {
                const token = this.visit(node.stringLiteral, ctx);
                return { type: 'string', value: token.image.substr(1, token.image.length - 2), token };
            }
            else if (node.qName) {
                const value = this.visit(node.qName, ctx);
                const scope = ctx.stack.peek();
                const ref = scope.resolve(value, ctx);
                if (ref) {
                    return { type: ref.type, value: ref.value, token: value[value.length - 1] };
                }
            }
            else if (node.hashRef) {
                const value = this.visit(node.hashRef, ctx);
                const scope = ctx.stack.peek();
                const ref = scope.resolve(value, ctx);
                if (ref) {
                    return { type: ref.type, value: ref.value, token: value[0] };
                }
            }
            return;
        }
        newDecl(node, ctx) {
            if (node.Identifier) {
                const typeName = node.Identifier[0].image;
                const type = ctx.types.get(typeName);
                if (type) {
                    const scope = new Scope(typeName);
                    type.init(scope);
                    node.Identifier[0].ref = scope;
                    return scope;
                }
                else {
                    ctx.errors.push(new GreyCatLintError(`Unknown type '${typeName}'`, node.Identifier[0]));
                }
            }
            return;
        }
        arrayDecl(node, ctx) {
            if (node.expr) {
                return node.expr.map((e) => this.visit(e, ctx));
            }
            return [];
        }
        typedArrayDecl(node, ctx) {
            if (node.Identifier) {
                return this.visit(node.arrayDecl, ctx);
            }
            return;
        }
        stringLiteral(node) {
            if (node.value) {
                return node.value[0];
            }
            return;
        }
        qName(node) {
            if (node.Identifier) {
                return node.Identifier;
            }
            return;
        }
        hashRef(node) {
            if (node.Identifier) {
                return node.Identifier;
            }
            return;
        }
    };
};
function verifyParams(params, ctx) {
    if (params.length > 0) {
        params.forEach((p) => {
            switch (p.ref.type) {
                case 'string':
                    if (!p.name) {
                        const name = p.ref.value;
                        ctx.errors.push(new GreyCatLintError(`StringLiteral parameter "'${name}'" must be named`, p.ref.token));
                    }
                    break;
                case 'number':
                    if (!p.name) {
                        ctx.errors.push(new GreyCatLintError(`Number parameter '${p.ref.value}' must be named`, p.ref.token));
                    }
                    break;
                case 'boolean':
                    if (!p.name) {
                        ctx.errors.push(new GreyCatLintError(`Boolean parameter '${p.ref.value}' must be named`, p.ref.token));
                    }
                    break;
            }
        });
    }
}
function initTypings(ctx) {
    ctx.typings.functions.forEach(({ name, contract }) => {
        const fScope = new Scope(name);
        if (contract) {
            contract.forEach((c) => {
                Object.keys(c).forEach((prop) => {
                    fScope.declareParam(prop, c[prop]);
                });
            });
        }
        ctx.stack.peek().setRef(name, { type: 'function', value: fScope });
    });
    ctx.typings.types.forEach(({ type, constants, properties }) => {
        const tNode = new NodeType(type);
        if (constants) {
            constants.forEach((c) => {
                const t = string2type(c.type);
                if (t === 'function') {
                    const scope = new Scope(c.name);
                    tNode.setFunc(c.name, {
                        private: false,
                        static: true,
                        scope,
                    });
                }
                else if (t === 'reference') {
                    const scope = new Scope(c.name);
                    tNode.setRef(c.name, {
                        private: false,
                        static: true,
                        scope,
                    });
                }
                else {
                    tNode.setAtt(c.name, {
                        private: false,
                        static: true,
                        type: t,
                    });
                }
            });
        }
        if (properties) {
            properties.forEach((p) => tNode.setAtt(p.name, {
                private: false,
                static: false,
                type: string2type(p.type),
            }));
        }
        ctx.types.set(type, tNode);
    });
}
function asPath(qName) {
    return qName.map((q) => q.image).join('.');
}
function typeCheck(src, target, ctx) {
    if (target === 'any' || src === 'any') {
        return true;
    }
    return src === target;
}
//# sourceMappingURL=linter.js.map